import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
export function ListingCardSkeleton(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-3 desktop:gap-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-[245px] w-full animate-pulse rounded-sm bg-surface-base-secondary desktop:h-[289px] desktop:rounded-md" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full flex-col gap-2"><div className="h-5 w-3/4 animate-pulse rounded bg-surface-base-secondary" /><div className="h-4 w-1/2 animate-pulse rounded bg-surface-base-secondary" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}